<template>
    <div>

        <div class="custom-modal" :class="{ 'show' : is_open_modal }">
            <div class="custom-modal-window">
                <div class="btn btn-close" @click="closeModal()"></div>
                <div v-if="modalDeal">
                    <div class="deal-image">
                        <img class="bg" :src="modalDeal.image_photo_url" v-if="modalDeal.image_photo_url">
                        <div class="logo">
                            <img :src="modalDeal.image_logo_url" v-if="modalDeal.image_logo_url">
                        </div>
                    </div>
                    <div class="px-8 py-6">
                        <h2 class="mb-3">{{ modalDeal.title }}</h2>
                        <div class="d-flex flex-wrap pb-1">
                            <div class="deal-summary mb-3 me-3" v-if="modalDeal.summary">{{ modalDeal.summary }}</div>
                            <div class="deal-summary deal-summary-orange mb-3" v-if="daysLeft(modalDeal.valid_to)">{{ daysLeft(modalDeal.valid_to) }} dagar kvar</div>
                        </div>
                        <div class="mb-8" v-html="modalDeal.description_long"></div>

                        <div class="mb-6" v-if="modalDeal.discount_code != null">
                            <h3>Rabattkod</h3>
                            <div class="discount-code"><span>{{ modalDeal.discount_code }}</span><div class="copy-code" @click="copy(modalDeal.discount_code)"><img src="/images/clinic/icon-copy.svg"><div>Kopiera</div><div class="confirmation" :class="{ 'show' : copy_confirmation }">Kopierat</div></div></div>
                        </div>

                        <a :href="modalDeal.url" class="btn btn-primary btn-sm w-100" target="_blank" v-if="modalDeal.url"><img style="height: 16px; margin-right: 8px;" src="/images/clinic/icon-new-window.svg">Till <span v-if="modalDeal.company_name">{{ modalDeal.company_name }}</span><span v-else>erbjudandet</span></a>

                    </div>
                    
                </div>
            </div>
            <div class="custom-modal-background" @click="closeModal()"></div>
        </div>

        <div class="row g-8 g-lg-10 g-xxl-14 mb-14">
            <div class="col-12 col-sm-6 col-lg-4" v-for="deal in deals" v-if="dealValid(deal.valid_from, deal.valid_to) == true">
                <div class="deal-box">

                    <div class="deal-image" @click="openModal(deal.id)">
                        <img class="bg" :src="deal.image_photo_url" v-if="deal.image_photo_url">
                        <div class="logo">
                            <img :src="deal.image_logo_url" v-if="deal.image_logo_url">
                        </div>
                    </div>

                    <div class="px-8 py-6">
                        <h3 class="mb-3">{{ deal.title }}</h3>
                        <div class="d-flex flex-wrap pb-1">
                            <div class="deal-summary mb-3 me-3" v-if="deal.summary">{{ deal.summary }}</div>
                            <div class="deal-summary deal-summary-orange mb-3" v-if="daysLeft(deal.valid_to)">{{ daysLeft(deal.valid_to) }} dagar kvar</div>
                        </div>
                        <p class="mb-0">{{ deal.description_short }}</p>                    
                    </div>

                    <div class="position-absolute w-100 px-8 py-6" style="bottom: 0; left:0;">
                        <div class="btn btn-primary btn-sm w-100" @click="openModal(deal.id)">Visa erbjudande</div>
                    </div>

                </div>
            </div>

        </div>
    </div>
</template>

<script>
import moment from 'moment'

export default {

    props: {
        deals: {
            required: true
        }
    },

    data () {
        return {
            now: Date.now(),
            selected_deal:null,
            is_open_modal:false,
            copy_confirmation:false,
        }
    },

    computed: {

        modalDeal(){
            // return this.deals.map(this.id == selected_id)
            return this.deals.find(p => p.id == this.selected_deal)
        },

    },

    methods: {

        dealValid(valid_from, valid_to) {

            const valid_from_date = moment(valid_from)
            const valid_to_date = moment(valid_to)
            const now = moment()

            if( (valid_from == null || valid_from_date.isBefore(now)) && (valid_to == null || valid_to_date.isAfter(now)) )
            {
                return true
            }

            return false
            
        },

        daysLeft(valid_to) {
            if(valid_to != null)
            {
                const valid_to_date = moment(valid_to)
                const now = moment()
                var diff = valid_to_date.diff(now, 'days')
                //diff++
                return diff
            }
            
        },

        openModal(id){
            this.selected_deal = id
            this.is_open_modal = true
            jQuery("html").addClass('hidescroll');
        },

        closeModal(){
            this.is_open_modal = false
            jQuery("html").removeClass('hidescroll');
        },

        async copy(mytext) {
            try {
              await navigator.clipboard.writeText(mytext);
              this.copy_confirmation = true;
              var _self = this;
              setTimeout(function() {
                  _self.copy_confirmation = false
                }, 2000);

            } catch($e) {
            }
          }

    }

}
</script>
